import type {MetricsDashboardDto} from '@devmil/contracts';

import {
  describeSourcedMetric,
  formatDays,
  formatMetricValue,
  formatMoney,
  formatPercent,
} from '../../lib/format.js';

const Stat = ({
  label,
  value,
  caption,
}: {
  label: string;
  value: string;
  caption: string;
}) => (
  <div className="dm-stat">
    <span>{label}</span>
    <strong>{value}</strong>
    <code>{caption}</code>
  </div>
);

/**
 * Os quatro números do topo.
 *
 * A legenda deixou de ser um texto fixo. "últimos 30 dias" embaixo de um traço
 * era a tela prometendo uma janela que ninguém mediu: o coletor entrega alcance
 * de conta em janelas de um dia, e somar trinta dias diários não dá alcance de
 * trinta dias, porque a mesma pessoa apareceria trinta vezes. Quando a medição
 * que existe é de outro tamanho, a legenda diz qual é, que é a resposta honesta
 * que o achado F13 cobrou.
 */
export const MetricGrid = ({metrics}: {metrics: MetricsDashboardDto}) => (
  <div className="dm-stats" role="group" aria-label="Métricas do período">
    <Stat
      label="Alcance"
      value={formatMetricValue(metrics.reach)}
      caption={describeSourcedMetric(
        metrics.reach,
        `últimos ${formatDays(metrics.windowDays)}`,
      )}
    />
    <Stat
      label="Salvamentos"
      value={formatMetricValue(metrics.saves)}
      caption={describeSourcedMetric(
        metrics.saves,
        `${formatPercent(metrics.savesRateOfReach)} do alcance`,
      )}
    />
    <Stat
      label="MAPA iniciados"
      value={formatMetricValue(metrics.mapaStarted)}
      caption="ação atribuível"
    />
    {/* Receita sem medição aparece como Indisp., nunca como R$ 0,00. */}
    <Stat
      label="Receita atribuída"
      value={formatMoney(metrics.attributedRevenue)}
      caption="não vira zero"
    />
  </div>
);
